/**
 * @generated SignedSource<<ae60971d820787a608cbf843108307c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EstimateCreateInput = {
  estimate: Date;
  jobId: string;
};
export type updateTimeInputCreateEstimateMutation$variables = {
  connections: ReadonlyArray<string>;
  input: EstimateCreateInput;
};
export type updateTimeInputCreateEstimateMutation$data = {
  readonly createEstimate: {
    readonly node: {
      readonly estimate: Date | null | undefined;
      readonly id: string;
      readonly insertedAt: Date | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateTimeInputCreateEstimateMutation = {
  response: updateTimeInputCreateEstimateMutation$data;
  variables: updateTimeInputCreateEstimateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": (v1/*: any*/),
  "concreteType": "EstimateEdge",
  "kind": "LinkedField",
  "name": "createEstimate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Estimate",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "insertedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTimeInputCreateEstimateMutation",
    "selections": [
      (v2/*: any*/)
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTimeInputCreateEstimateMutation",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": null,
        "handle": "appendEdge",
        "key": "",
        "kind": "LinkedHandle",
        "name": "createEstimate",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f6cf08331d14b6dd3602134088be675a",
    "id": null,
    "metadata": {},
    "name": "updateTimeInputCreateEstimateMutation",
    "operationKind": "mutation",
    "text": "mutation updateTimeInputCreateEstimateMutation(\n  $input: EstimateCreateInput!\n) {\n  createEstimate(input: $input) {\n    node {\n      id\n      estimate\n      insertedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1dc92ae0580c515883021bc52a13e22e";

export default node;
